import { render, staticRenderFns } from "./UserPlanDialog.vue?vue&type=template&id=5b00fc04"
import script from "./UserPlanDialog.vue?vue&type=script&lang=js"
export * from "./UserPlanDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPlanDialog.vue?vue&type=style&index=0&id=5b00fc04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports